import { render } from "./funFact.vue?vue&type=template&id=56cd896e&scoped=true"
import script from "./funFact.vue?vue&type=script&lang=js"
export * from "./funFact.vue?vue&type=script&lang=js"

import "./funFact.vue?vue&type=style&index=0&id=56cd896e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cd896e"]])

export default __exports__